import React, { useEffect } from 'react';
import { Col, Container, Row } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import ChangeViewMode from '../components/manage-approval/ChangeViewMode';
import ConfirmList from '../components/manage-approval/ConfirmList';
import ConditionHistory from '../components/manage-approval/ConditionHistory';
import ModalManageApproval from '../components/manage-approval/ModalManageApproval';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { resetMessage, setSelectedViewMode, setOrganizationId } from '../redux/slices/approval';
import { getAdminPowerUsers } from '../redux/slices/user';
import { getConfirmList } from '../redux/slices/approval';
import { getBusinessTypeOptions, getSteelCategoryOptions, getSteelMakerOptions, getOrganizationBaseOptions } from '../redux/slices/options';
import { getOrganizations } from '../redux/slices/organization';
import { APPROVAL_VIEW_MODES } from '../constants';

const ManageApproval = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { hasError, serverMessage } = useSelector((state: RootState) => state.approval);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // 初期データを取得する
  // 初期表示を「未承認一覧」にする
  useEffect(() => {
    dispatch(getSteelMakerOptions());
    dispatch(getBusinessTypeOptions());
    dispatch(getSteelCategoryOptions());
    dispatch(getOrganizationBaseOptions());
    dispatch(getOrganizations());
    dispatch(getAdminPowerUsers());
    dispatch(getConfirmList());
    dispatch(setOrganizationId());
    return dispatch(setSelectedViewMode(APPROVAL_VIEW_MODES.CONFIRM));
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したとき
   */
  const dismiss = (): void => {
    dispatch(resetMessage());
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row id="pageTitle" noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('approval.manage')} subtitle="Manage Approval" className="text-sm-left" />
        <Col sm="4" className="col d-flex align-items-center">
          <ChangeViewMode />
        </Col>
      </Row>

      <Notification theme={hasError ? 'danger' : 'success'} isOpen={serverMessage !== undefined && serverMessage.length > 0} message={serverMessage} dismissCallback={dismiss} />

      <ConfirmList />
      <ConditionHistory />

      <ModalManageApproval />
    </Container>
  );
};

export default ManageApproval;
